import { render, staticRenderFns } from "./retrospect.vue?vue&type=template&id=09c50e88&scoped=true"
import script from "./retrospect.vue?vue&type=script&lang=js"
export * from "./retrospect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c50e88",
  null
  
)

export default component.exports